module.exports = __webpack_public_path__ + "static/img/7-4.692aba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7-4.png
// module id = Bmx6
// module chunks = 1